module.exports = __webpack_public_path__ + "img/pdf_file_image.a4fbc160.png";